import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { format } from "date-fns";
import { REACT_APP_API_BASE } from '../../config';
import './styles.scss';

class RenderFiles extends Component {

    async downloadFile(e, doc) {
        e.preventDefault();
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/news/document/${doc.newsFileId}`);
        
        if (res.ok) {
            const exportReport = await res.blob();
            var blob = new Blob([exportReport], { type: doc.contentType });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = doc.fileName
            link.click();
        }
    }

    render() {

        if (!this.props.documents) return null;

        if (this.props.documents.length === 0) return null;

        return (
            <div className="post__files">
                <h2 className="post__files-heading">Filer</h2>
                <ul className="post__files-list">
                    {this.props.documents.map(document => {
                        return (
                            <li key={document.newsFileId}>
                                <button
                                    type="button"
                                    className="post__file-link"
                                    onClick={(e) => this.downloadFile(e, document)}
                                >
                                    {document.originalFileName}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

const RenderBlock = (props) => {
    return (
        <div dangerouslySetInnerHTML={{__html: props.content}}></div>
    );
};

const RenderImage = (props) => {
    if (!props.image) return null;

    return (
        <div className="post__image single-blog-image">
            <img src={props.image.src} alt={props.image.alt} />
        </div>
    );
};

const RenderTags = (props) => {
    if (!props.tags) return null;

    if (props.tags.length === 0) return null;

    return (
        <div className="post__tags">
            <i className="post__tags-icon"></i>
            <div className="post__tags-list">
                {props.tags.map(tag => {
                    return (
                        <a key={tag.newsTagId} href={`/news/tag/${tag.tag}`} title={tag.tag}>{tag.tag}</a>
                    );
                })}
            </div>
        </div> 
    );
};

const Post = (props) => {  
    
    return (
        <section className="post">
            {props.toolbar}
            <div className="post__wrapper content-padding">
                <RenderImage {...props} />

                <div className="post__content single-blog-content">
                    <h1>{props.heading}</h1>
                    <div className="post__preamble">
                        <RenderBlock content={props.preambleBlock} />
                    </div>
                    
                    
                    {<div className="post__meta">
                        {/*<RenderAuthor {...props} />*/}
                        <span className="post__meta-calendar">{format(new Date(props.publishedOn),'yyyy-MM-dd')}</span>
                    </div>}

                    <div className="post__body">
                        <RenderBlock content={props.postBlocks} />
                    </div>
                    <RenderFiles {...props} />
                    <RenderTags {...props} /> 
                </div>
            </div>
        </section>
    );
};

export default withRouter(Post);